export default __webpack_public_path__ + "static/media/life_center.a66682be.jpg";